import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="font-heading text-xl font-bold text-primary-600 whitespace-nowrap">
              Hitozuma 专题
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname.includes(cat.slug)
                    ? 'text-primary-600'
                    : 'text-foreground-600 hover:text-primary-500'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-lg hover:bg-background-100 transition-colors"
            aria-label="Toggle menu"
          >
            <i className={`text-xl text-foreground-700 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer py-2"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer py-2"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer py-2"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}